import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import updateHeaders from './apiHeaders';

// Generate default queries for each model
export function defaultQueriesFor(build, name, pluralName, useId = false) {
  const pluralLowerCase = pluralName.split(/\.?(?=[A-Z])/).join('_').toLowerCase();

  return {
    // Index
    [`get${pluralName}`]: build.query({
      query: (params) => {
        const queryString = new URLSearchParams(params).toString();
        return `/${pluralLowerCase}?${queryString}`;
      },
      providesTags: [name]
    }),

    // Show
    [`get${name}ById`]: build.query({
      query: (id) => `/${pluralLowerCase}/${id}`,
      providesTags: [name]
    }),

    // Create
    [`create${name}`]: build.mutation({
      query: (initialItem) => ({
        url: `/${pluralLowerCase}`,
        method: 'POST',
        body: initialItem
      }),
      invalidatesTags: [name]
    }),

    // Update
    [`update${name}`]: build.mutation({
      query: (updatedItem) => ({
        // FUTURE get rid of uid distinction, just use slug/id??
        url: `/${pluralLowerCase}/${useId ? updatedItem.id : updatedItem.uid}`,
        method: 'PUT',
        body: updatedItem
      }),
      invalidatesTags: [name]
    }),

    // Delete
    [`delete${name}`]: build.mutation({
      query: (id) => ({
        url: `/${pluralLowerCase}/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: [name]
    })
  };
}

export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/',
    prepareHeaders: (headers) => {
      return updateHeaders(headers);
    },
  }),
  tagTypes: [],
  endpoints: build => ({}),
});
